import { render, staticRenderFns } from "./Tratamientos.vue?vue&type=template&id=1a089f9e&scoped=true&"
import script from "./Tratamientos.vue?vue&type=script&lang=ts&"
export * from "./Tratamientos.vue?vue&type=script&lang=ts&"
import style0 from "./Tratamientos.vue?vue&type=style&index=0&id=1a089f9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a089f9e",
  null
  
)

export default component.exports